module.exports = __webpack_public_path__ + "img/ax.ecabe5e7.svg";